import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
// 获取脱敏后的数据
// refference https://docs.qq.com/sheet/DY2NjU0xmS3p2aHpE?tab=xhz9ia&_t=1639635300273
var codeMap = {
  A01_: maskUserName,
  A02_: maskPhone,
  A07_: mask11,
  A08_: maskEmail,
  B05_: function B05_(str) {
    return maskCode(str, 0, 4);
  },
  B07_: maskUserName,
  C01_: mask11,
  G09_: maskIp,
  A05_: maskAddress,
  A12_: maskDate,
  A13_: mask11,
  A14_: mask11
};

/**
 * 获取脱敏后的数据
 * @method getMaskData
 * @param {object} obj
 * @return {object}
 * @example
 * refference https://docs.qq.com/sheet/DY2NjU0xmS3p2aHpE?tab=xhz9ia&_t=1639635300273
 * 
 * import { getMaskData } from '@zz-common/zz-utils'
 * getMaskData({
    A01_01: '测 试',
    A01_02: '宋',
    A01_03: '测试 条件',
    A02_02: 17667676767,
    A07_01: 1244,
    A08_01: 'test@zhuha.com',
    B05_01: 130333454456666,
    G09_01: '192.178.167.6',
    A05_01: '北京市 海淀区 中关村大街',
    A12_01: '2021-09-09',
  })
 */
export default function getMaskData(obj) {
  var res = {};
  Object.keys(obj).forEach(function (item) {
    if (codeMap[item && item.slice(0, 4)]) {
      try {
        res[item] = replaceSpace(codeMap[item.slice(0, 4)](obj[item]));
      } catch (error) {
        res[item] = obj[item];
      }
    } else {
      res[item] = obj[item];
    }
  });
  return res;
}
// 截取第一个字符和最后一个
function mask11(str) {
  str = str + '';
  if (str.length <= 2) {
    return str;
  } else {
    return maskCode(str, 1, 1);
  }
}
function replaceSpace(str) {
  return str.replace(/\s/g, '_');
}
function maskUserName(str) {
  str = str + '';
  if (str.length == 1) {
    return str;
  } else {
    return maskCode(str, 0, 1);
  }
}
function maskPhone(str) {
  str = str + '';
  return maskCode(str, 3, 2);
}
function maskCode(str, frontLen, endLen) {
  str = str + '';
  var len = str.length - frontLen - endLen;
  var mask = '';
  for (var i = 0; i < len; i++) {
    mask += '*';
  }
  return str.substring(0, frontLen) + mask + str.substring(str.length - endLen);
}
function maskEmail(str) {
  str = str.split('@');
  var name = str[0];
  var host = str[1];
  return name.replace(/[\s\S]/g, '*') + '@' + host;
}
function maskIp(str) {
  str = str.split('.');
  return str[0] + '.*.*.*';
}
function maskAddress(str) {
  str = str + '';
  return str.replace(/\s\S+$/, ' ****');
}
function maskDate(str) {
  str = str + '';
  return str.replace(/^(\d+)([-|/])(\d+)([-|/])(\d+)$/gi, function (a, b) {
    return b + '-' + '**' + '-' + '**';
  });
}